export default __webpack_public_path__ + "static/media/contact.68068f1d.png";